export enum ChatEntityType {
  Form = 'form',
  Appointment = 'appointment',
}
